import React, { useEffect, useState } from 'react';
import {
  Create,
  FormTab,
  required,
  TabbedForm,
  SelectInput,
  TextInput,
  useDataProvider,
  FileInput,
  FileField,
  AutocompleteInput
} from 'react-admin';
import { TinyMCEEditor } from '../../Components';
import { booleanInteger, evidenceType, status, uploadChoice } from '../../utils/choices';
import { EvidenceFormStyles } from '../../styles';
import { makeStyles } from '@material-ui/core/styles';
import EvidenceImageInput, { validateEvidenceImage } from './ImageUploadInput';

// Material-UI adds an extra div around AutoCompleteInput that sets a flex-grow: 1
// which pushing the component to the left. In order to disable need another wrapper to overwrite it
const useStyles = makeStyles({
  root: {
    flexGrow: 0,
  },
});

const EvidenceCreate = (props) => {
  const { resource } = props;
  const classes = EvidenceFormStyles();
  const [plots, setPlots] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [uploadChoiceValue, setUploadChoiceValue] = useState();
  const autoCompleteStyle = useStyles();

  const newProps = { ...props, redirect: '/evidence' };

  const dataProvider = useDataProvider();

  const handleUploadChoiceChange = (e) => {
    console.log(e.target);
    setUploadChoiceValue(e.target.value);
  }

  useEffect(() => {
    dataProvider
      .getList('plot', {})
      .then(({ data }) => {
        const plotArray = data.map(({ id, name }) => ({ id, name }));
        setPlots(plotArray);
        setUploadChoiceValue(uploadChoice[0].id)
      })
      .catch((error) => {
        console.log(error);
      });
    dataProvider
      .getList('template', {})
      .then(({ data }) => {
        const templateData = data.map(({ id, name, template }) => ({ id, name, template }));
        setTemplates(templateData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <Create title={`resources.${resource}.titles.create`} {...props}>
      <TabbedForm {...newProps} >
        <FormTab label="Editor">
          <div className={classes.main}>
            <TextInput
              source="name"
              label="Evidence Name"
              validate={required()}
            />
            <SelectInput
              source="type"
              choices={evidenceType}
              validate={required()}
            />
            <SelectInput
              source="status"
              choices={status}
              validate={required()}
            />
            {/* <SelectInput
              source="plot"
              choices={plots}
              validate={required()}
            /> */}
            <div className={autoCompleteStyle.root}>
              <AutocompleteInput
                source="plot"
                choices={plots}
                shouldRenderSuggestions={(val) => val.trim().length > 0}
                validate={required()}
              />
            </div>
            <SelectInput
              source="uploadChoice"
              label="Upload Choice"
              choices={uploadChoice}
              validate={required()}
              defaultValue={uploadChoiceValue}
              onChange={handleUploadChoiceChange}
            />
            {uploadChoiceValue == 'VIDEO' && <SelectInput
              source="videoEvidenceLoop"
              label="Loop video evidence"
              choices={booleanInteger }
              validate={required()}
              defaultValue={1}
            />}
          </div>
          {uploadChoiceValue === uploadChoice[0].id && <TinyMCEEditor source="content" templates={templates} editorWidth='802px' />}
          {uploadChoiceValue === uploadChoice[1].id && <FileInput
            preview
            source="pdf"
            label="Upload Pdf File"
            accept="application/pdf"
            placeholder={<p>Drop your file here</p>}>
            {/* <PreviewImageField/> */}
            <FileField source="src" title="title" />
          </FileInput>
          }
          {uploadChoiceValue === uploadChoice[2].id && <FileInput
            preview
            source="video"
            label="Upload Video File"
            accept="video/*"
            placeholder={<p>Drop your file here</p>}>
            <FileField source="src" title="title" />
          </FileInput>
          }
          {uploadChoiceValue === 'IMAGE' && (
            <EvidenceImageInput
              source="image"
              validate={[required(), validateEvidenceImage]}
            />
          )}
        </FormTab>
      </TabbedForm>
    </Create>
  );
};

export default EvidenceCreate;
